import { render } from "./TrocarSenha.vue?vue&type=template&id=6bccf2f1"
import script from "./TrocarSenha.vue?vue&type=script&lang=js"
export * from "./TrocarSenha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__